import { useTranslation } from "react-i18next"
import { AnswerButton } from "./AnswerButton"
import type { IAnswerProps } from "./types"

export function AnswerBoolean({ answer }: IAnswerProps) {
  const { t } = useTranslation()

  if (!answer) return null

  return <AnswerButton color={answer.value ? "green" : "red"}>{t(answer.value ? "Yes" : "No")}</AnswerButton>
}
